// wrapper o szerokości wyświetlanej zawartości

import React, { ReactNode } from 'react';
import { Container as ContainerMui } from '@mui/material';
import { useRWD } from 'hooks';

const Container = ({ children, style }: { children: ReactNode; style?: React.CSSProperties; fullWidth?: boolean }) => {
  const { isMobile } = useRWD();

  return (
    <ContainerMui style={style} maxWidth="xl" disableGutters={isMobile}>
      {children}
    </ContainerMui>
  );
};

export default Container;
